// Centralized compliance constants. Update these to keep the whole site in sync.

export const COMPANY = {
    // Full registered legal entity (used on Terms, Privacy, Licensing,
    // Contact, Accessibility, and copyright lines).
    fullLegalName:
        "Endurance Casualty Insurance Agency Inc. d/b/a Endurance Casualty Insurance Agency",
    // Display brand on marketing surfaces (header, hero, footer column
    // identity, "About"-style copy where the d/b/a would feel visually heavy).
    legalName: "Endurance Casualty Insurance Agency",
    shortName: "Endurance Casualty",
    address: "59 Hollow Rd, Stony Brook, NY 11790",
    phone: "855.900.7405",
    phoneTel: "+18559007405",
    email: "contact@endurancecasualty.com",
    domain: "endurancecasualty.com",
    website: "https://www.endurancecasualty.com/",
};

export const CONSENT_VERSION = "2026-06-01-v2";

// Producer of record + state-by-state license list. Verified against the
// National Insurance Producer Registry (NIPR). NPN is the canonical
// producer identifier used by all U.S. state insurance regulators.
export const PRODUCER = {
    name: "George Goldman",
    npn: "3291155",
};

export const STATE_LICENSES = [
    { state: "New York", code: "NY", lines: "Property & Casualty Broker", number: "BR-781418" },
    { state: "New York", code: "NY", lines: "Life, Accident & Health Agent", number: "LA-781418" },
    { state: "Connecticut", code: "CT", lines: "Insurance Producer", number: "3291155" },
    { state: "Florida", code: "FL", lines: "Life, Health & Variable Contracts Insurance Agent", number: "W851925" },
    { state: "Florida", code: "FL", lines: "Travel Insurance Agent", number: "W851925" },
    { state: "Florida", code: "FL", lines: "Personal Lines Property & Casualty Insurance Agent", number: "W851925" },
    { state: "North Carolina", code: "NC", lines: "Insurance Producer", number: "3291155" },
    { state: "New Jersey", code: "NJ", lines: "Insurance Producer", number: "202551" },
    { state: "Pennsylvania", code: "PA", lines: "Non-Resident Producer (Individual)", number: "391388" },
    { state: "Texas", code: "TX", lines: "General Lines Agency / Agent", number: "3494843" },
    { state: "Texas", code: "TX", lines: "Life Agent / Agency", number: "3494855" },
    { state: "Texas", code: "TX", lines: "Personal Lines P&C Agent / Agency", number: "3494863" },
    { state: "Virginia", code: "VA", lines: "Insurance Producer", number: "824813" },
    { state: "Virginia", code: "VA", lines: "Limited Lines Producer", number: "824813" },
];

// Agency-entity licenses. The agency itself holds its own NPN and a separate
// set of state licenses, distinct from the individual producer of record.
export const AGENCY = {
    legalName: "Endurance Casualty Insurance Agency Inc",
    npn: "7567370",
};

export const AGENCY_LICENSES = [
    { state: "New York", code: "NY", lines: "Property & Casualty Broker", number: "BR-984002" },
    { state: "New York", code: "NY", lines: "Life, Accident & Health Broker", number: "LB-984002" },
    { state: "Connecticut", code: "CT", lines: "Insurance Producer", number: "3004227875" },
    { state: "North Carolina", code: "NC", lines: "Corporation", number: "3004227893" },
    { state: "New Jersey", code: "NJ", lines: "Insurance Producer", number: "1067652" },
    { state: "Pennsylvania", code: "PA", lines: "Non-Resident Producer Agency", number: "1318401" },
    { state: "Florida", code: "FL", lines: "Licensed Insurance Agency", number: "L136675" },
    { state: "Texas", code: "TX", lines: "General Lines Agency / Agent", number: "3498448" },
    { state: "Texas", code: "TX", lines: "Personal Lines P&C Agent / Agency", number: "3498449" },
];

export const DISCLAIMERS = {
    stateScope:
        "Insurance products are offered only in jurisdictions where Endurance Casualty and its producers are properly licensed and appointed. Product availability varies by state, carrier, underwriting, and policy terms.",
    product:
        "Submission of a request does not bind coverage or guarantee premium savings. Coverage availability, limits, deductibles, exclusions, endorsements, and premiums vary by carrier, underwriting, policy form, and state.",
    notInsurer:
        "Endurance Casualty Insurance Agency Inc. d/b/a Endurance Casualty Insurance Agency is an independent insurance agency, not an insurance company. Insurance products are offered only in jurisdictions where the agency and its producers are properly licensed, appointed, or otherwise authorized. Coverage is not bound unless confirmed in writing by an authorized insurer or licensed producer.",
    coverageGeneric:
        "Coverage options tailored to your needs, subject to policy terms, limits, deductibles, exclusions, underwriting, and carrier availability.",
    contactConsent:
        "By submitting this form, you request that Endurance Casualty or a licensed producer contact you by phone or email about your insurance inquiry and related insurance products or services. You may opt out of marketing emails at any time. Opting out of marketing communications will not prevent us from sending transactional, servicing, legal, compliance, or policy-related communications.",
    privacyAtForm:
        "We collect the information you submit to respond to your insurance inquiry, evaluate coverage options, match you with a licensed producer, prepare submissions when appropriate, maintain communication and consent records, and comply with applicable law. Please review our Privacy Notice and Terms of Service before submitting.",
    sensitiveInfoWarning:
        "Do not include Social Security numbers, payment information, bank information, medical records, claim documents, identity documents, passwords, or other highly sensitive information in this form.",
    electronicConsent:
        "By submitting this form, you consent to receive communications, disclosures, notices, agreements, authorizations, records, and other information from Endurance Casualty and its licensed producers electronically, including by email and through this website, where permitted by law. You confirm that you can access and retain electronic records and that you have provided a valid email address. You may withdraw this consent or request paper copies at any time by contacting us at contact@endurancecasualty.com or 855.900.7405. Withdrawal of consent will not affect the legal validity of records previously delivered electronically.",
    floridaSpecific:
        "Florida residents: Flood, windstorm, hurricane, and named-storm coverages may require separate policies, endorsements, deductibles, exclusions, or carrier approvals. Florida producer license number: W851925.",
    texasSpecific:
        "Texas residents: Tornado, earthquake, hail, wildfire, and severe-weather coverages may require separate policies, endorsements, deductibles, exclusions, or carrier approvals. Texas General Lines license number: 3494843.",
};
